//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ColumnMatchDisplayItem } from './ColumnMatchDisplayItem';
import { TeacherImportColumn } from './Enums';

export class TeacherColumnMatchDisplayItem extends ColumnMatchDisplayItem {
    Column: TeacherImportColumn = TeacherImportColumn.FirstName;

    constructor(initializer?: Partial<TeacherColumnMatchDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static override readonly ClassName: string = "TeacherColumnMatchDisplayItem";
}
